import { keyframes, styled } from '@mui/material/styles';

const cursorBlink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;

export const StreamingCursor = styled('span')(({ theme }) => ({
  display: 'inline-block',
  width: 2,
  height: '1em',
  backgroundColor: theme.palette.primary.main,
  marginLeft: theme.spacing(0.25),
  animation: `${cursorBlink} 1s step-end infinite`,
  verticalAlign: 'text-bottom',
}));
